import { Market } from '@/common/types/market';

export default function useGetActiveMarketsCopy(markets: Market[]) {
  return markets && markets.length > 0
    ? markets
        .map((market, index) =>
          index === markets.length - 1 && markets.length > 1
            ? 'and ' + market.name
            : market.name
        )
        .join(', ')
    : '';
}
